import React from 'react';
import { Box, Typography } from '@mui/material';
import * as styles from './styles';

function Copyrights() {
    const year = new Date().getFullYear();

    return (
        <Box sx={styles.copyrightBar}>
            <Typography sx={styles.copyrightText}>
                © {year} ECAL. All rights reserved.
            </Typography>
            <Typography sx={styles.copyrightText}>
                The official calendar marketing solution of the world's best brands.
            </Typography>
        </Box>
    );
}

export default Copyrights;
